import {
    getDefaultShouldShortenEventDuration,
    isSpeedyMeetingSetByTenant,
} from 'owa-calendar-cloud-settings';

/**
 * Show the speedy meeting teaching bubble if:
 * - shouldAdjustStartTimeEndTime is true
 * - the setting is turned on and
 * - the setting is set by the tenant
 */
export default function shouldShowSpeedyMeetingsTeachingUI(
    shouldAdjustStartTimeEndTime: boolean | undefined
): boolean {
    return (
        !!shouldAdjustStartTimeEndTime &&
        getDefaultShouldShortenEventDuration() &&
        isSpeedyMeetingSetByTenant()
    );
}
